/*!
 * Api, uses Axios Promise based HTTP client for the browser and node.js
 * Authors: ['Jorge Brunal Perez (aka Diniremix)', 'Duverney Ortiz']
 * Version: 2020-04-23
 * https://git.sitimapa.co/openroute/openroute-admin
 * Released under the MIT License.
 */

import axios from 'axios';
import * as constants from '@/constants';
import store from '@/store';
import { logout, notify } from '@/helpers/$vs.js'

const API_BASE_URL = {
  main: constants.API_BASE_URL,
  // viki: 'https://viki-backend-dot-servi-forms.appspot.com/api',
  viki: 'https://capricasix-dot-servi-forms.appspot.com/api',
  V1: 'https://backend-dot-servi-forms.appspot.com/api'
}

//Add a request interceptor
axios.interceptors.request.use((config) => {
  // Do something before request is sent
  const elToken = config.token;
 
  if (elToken !== null) {
    config.headers = {
      ...config.headers,    
      'Content-Type' : 'application/json',
      'Authorization': `Bearer ${elToken}`
    };    
    return config;
  }
  return config;
}, (error) => {
  // Do something with request error
  console.warn('Error: interceptors request use:', error);
  return Promise.reject(error);
});

const getURL = (payload) =>{
  if (typeof payload === "object" || payload.constructor === Object) {
      if (!payload.hasOwnProperty("uri")) return API_BASE_URL.main;
      return API_BASE_URL[payload.uri];
  } else {
      console.error("validateExternalConfig: el payload esta mal formado.");
      return null;
  }
}

const getToken = (payload) => {
  if (typeof payload === "object" || payload.constructor === Object) {    
    if (!payload.hasOwnProperty("token")) return store.state.sessionToken;
    return payload.token;
  }else {
    console.error("getToken: el payload esta mal formado.");
    return null;
  }
}

const _logout = (external) => {
  if( Object.keys(external).length > 0 && external.constructor === Object) {
    notify('Sessión', 'La sessión del token externo ha expirado', 'danger')
  }else {
    notify('Sessión', 'La sessión ha expirado', 'danger')
    logout();
  }  
}

export default {
  PromisePost(endPoint,  data = {}, external = {}) {
    const baseUrl = getURL(external); 
    const token = getToken(external);
    const header = { token };
    return axios.post(baseUrl + endPoint, data, header);
  },

  async get (endPoint, external = {}) {
    try{
      const baseUrl = getURL(external); 
      const token = getToken(external);
      const header = { token, data: {} };
      const response = await axios.get(baseUrl + endPoint, header);     
      return response.data;
    }catch(defaultResposeError) {  
      const data = defaultResposeError.response.data;      
      if(data.status === 715) _logout(external);
      throw defaultResposeError.response.data;
    }
  },

  async post (endPoint, data = {}, external = {}) {    //external { uri: 'viki', token: 'elTokenAqui'} 
    try{
      const baseUrl = getURL(external); 
      const token = getToken(external);
      const header = { token };
      const response = await axios.post(baseUrl + endPoint, data, header);
      return response.data;
    }catch(defaultResposeError) {      
      const data = defaultResposeError.response.data;
      if(data.status === 715) _logout(external);
      throw defaultResposeError.response.data;
    }
  },

  async put (endPoint, data = {}, external = {}) {
    try{
      const baseUrl = getURL(external); 
      const token = getToken(external);
      const header = { token };
      const response = await axios.put(baseUrl + endPoint, data, header);
      return response.data;
    }catch(defaultResposeError) {
      const data = defaultResposeError.response.data;
      if(data.status === 715) _logout(external);
      throw defaultResposeError.response.data;
    }
  },

  async delete (endPoint, external = {}) {
    try{
      const baseUrl = getURL(external); 
      const token = getToken(external);
      const header = { token, data: {} };
      const response = await axios.delete(baseUrl + endPoint, header);
      return response.data;
    }catch(defaultResposeError) {
      const data = defaultResposeError.response.data;
      if(data.status === 715) _logout(external);
      throw data;
      
    }
  },

  async upload (endPoint, formData, external = {}) {
    try {
      const headers = {
        'Content-Type': 'multipart/form-data'
      }

      const baseUrl = getURL(external);
      const token = getToken(external);
      const header = { token, headers };
      const response = await axios.post(baseUrl + endPoint, formData, header);
      return response.data;
    } catch (defaultResposeError) {
      if(data.status === 715) _logout();
      throw defaultResposeError;
    }
 
  },
};
